import { Routes, Route } from 'react-router-dom';
import Error from './pages/Error.js';
import Home from './pages/Home';
import Menus from './pages/Menus.js';
import Burrow from './pages/Burrow.js';
import SeafoodLounge from './pages/SeafoodLounge.js';
import Rooms from './pages/Rooms.js';
import Weddings from './pages/Weddings.js';
import Events from './pages/Events.js';
import Christmas from './pages/Christmas.js';
import Contact from './pages/Contact.js';
import Footer from './components/Footer.jsx'; 

import NavBar from './components/NavBar.jsx';

function App() {
  return (
    <>
      <NavBar />
      <Routes>
        <Route path="*" element={<Error/>} />
        <Route path="/" element={<Home />} />
        <Route path="/menus" element={<Menus />} />
        <Route path="/burrow" element={<Burrow />} />
        <Route path="/seafoodLounge" element={<SeafoodLounge />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/weddings" element={<Weddings />} />
        <Route path="/events" element={<Events />} />
        <Route path="/christmas" element={<Christmas />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
